module.exports = __webpack_public_path__ + "static/img/reward1.671bc0af.png";